import { useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	onClick: () => void;
	Icon: LucideIcon;
	iconBg: string;
	iconColor: string;
	label: string;
	description?: string;
	hasDivider?: boolean;
};

export const SolutionItemActionRow: FC<Props> = ({
	onClick,
	Icon,
	iconBg,
	iconColor,
	label,
	description,
	hasDivider,
}) => {
	const theme = useTheme();

	return (
		<ListRow
			onClick={onClick}
			icon={<Icon size={theme.iconSize.sm} color={iconColor} />}
			iconBg={iconBg}
			title={label}
			subtitle={description}
			tabularSubtitle
			isLast={!hasDivider}
		/>
	);
};
